import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";

@Component({
  selector: "view-gis360-license-information",
  template: require('./view-gis360-license-information.component.html'),
})
export class ViewGIS360LicenseInformationComponent {
  dialogTitle = "";
  errorMessage = "";
  isLoading = false;
  // Sales order row of the main grid [license details shown at the top]
  selectedRow;
  // License Keys of the sales order [table]
  licenseKeyDetails = [];

  constructor(
    private dialogRef: MdDialogRef<ViewGIS360LicenseInformationComponent>,
    private licenseService: LicenseService,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.dialogTitle = this.dialogData.dialogTitle;
    this.selectedRow = this.dialogData.SelectedRow;
    this.getLicenseKeys();
  }

  getLicenseKeys() {
    this.isLoading = true;
    this.licenseService.getGIS360LicenseKeys(this.selectedRow.LicenseMasterId).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.licenseKeyDetails = data.DataObject;
          this.errorMessage = this.licenseKeyDetails.length == 0 ? "No license keys found." : "";
        } else {
          this.errorMessage = data.Error;
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.errorMessage = "Something went wrong.";
      },
    );
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/popup/view-gis360-license-information/view-gis360-license-information.component.ts